import {
  Paginator as PrimeReactPaginator,
  PaginatorCurrentPageReportOptions,
} from 'primereact/paginator';

import { IPaginatorProps } from './Paginator.types';

import './paginator.scss';

// "Showing 1-25 of 818" on the left, so the table needs no count of its own.
function CurrentPageReport({
  first,
  last,
  totalRecords,
}: PaginatorCurrentPageReportOptions) {
  return (
    <span className="std-paginator__report">
      {`Showing ${first.toLocaleString()}-${last.toLocaleString()} of ${totalRecords.toLocaleString()}`}
    </span>
  );
}

export default function Paginator({
  first,
  rows,
  totalRecords,
  rowsPerPageOptions,
  template = {
    layout:
      'CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink',
    CurrentPageReport,
  },
  leftContent,
  rightContent,
  onPageChange,
}: IPaginatorProps) {
  // Pages that read these from the URL can pass them as strings. PrimeReact's
  // Next button then adds them as text ('1' + '50' = '150') and jumps past the
  // last page, so they are made numbers here once for every list.
  return (
    <PrimeReactPaginator
      className="std-paginator"
      first={Number(first) || 0}
      rows={Number(rows) || undefined}
      totalRecords={Number(totalRecords) || 0}
      rowsPerPageOptions={rowsPerPageOptions}
      template={template}
      leftContent={leftContent}
      rightContent={rightContent}
      onPageChange={onPageChange}
    />
  );
}
